<script setup>
/**
 * NotificationsMenu
 * A slide-out menu (offcanvas) that displays a list of notifications.
 * It uses a bell icon as a trigger, which indicates an active state.
 * Notifications are displayed as individual toast components within the menu.
 */
import { ref, computed, onMounted, getCurrentInstance } from 'vue';
import { Offcanvas } from 'bootstrap';
import Button from "../Button.vue";
import Toast from "../toasts/Toast.vue";

const { proxy } = getCurrentInstance();
const store = proxy.$store;

const button = ref(null);
let offcanvasInstance = null;

const active = computed(() => store.state.notificationsMenu.active);
const items = computed(() => store.state.notificationsMenu.items);

const openMenu = () => {
    store.dispatch('notificationsMenu/openMenu');
};

const closeMenu = () => {
    if (offcanvasInstance) {
        offcanvasInstance.hide();
    }
};

const onCloseToast = (itemId) => {
    store.dispatch('notificationsMenu/removeItem', {
        itemId: itemId,
    });
};

onMounted(() => {
    const offcanvasElement = document.getElementById('notificationsOffcanvas');
    if (offcanvasElement) {
        offcanvasInstance = new Offcanvas(offcanvasElement);
        offcanvasElement.addEventListener('hidden.bs.offcanvas', () => {
            store.dispatch('notificationsMenu/hideMenu');
        });
    }
});
</script>

<template>
    <div>
        <Button ref="button" class="h-100 rounded-0" data-bs-toggle="offcanvas" data-bs-target="#notificationsOffcanvas"
                @click.native="openMenu">
            <i :class="{ 'active': active }" class="bi bi-bell-fill notification-icon"/>
        </Button>

        <div id="notificationsOffcanvas" class="offcanvas offcanvas-end bg-transparent border-0" tabindex="-1"
             aria-labelledby="notificationsOffcanvasLabel" @click="closeMenu">
            <div class="offcanvas-body pt-5">
                <Toast v-for="item in items" :key="item.id" class="m-0 mb-3 w-100" :title="item.title"
                       :body="item.data.message" :created-by="item.createdBy" :created-date="item.createdDate"
                       :download-url="item.data.downloadUrl" :more-info="item.data.moreInfo"
                       :percentage="item.data.percentage" :disable-auto-hide="true" :disable-animation="true"
                       :disable-close="false" :on-close="() => onCloseToast(item.id)" @click.stop.native/>
            </div>
        </div>
    </div>
</template>

<style scoped>
.notification-icon {
    transition-property: color;
    transition-duration: 300ms;
}

.notification-icon.active {
    color: #f60;
}
</style>
